import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import loader from 'shared/img/btn-loader.svg';
import van from 'shared/img/van.webp';
import lorry from 'shared/img/lorry.webp';

class BtnCart extends Component {
  state = {
    loading: false
  };

  componentDidUpdate(prevProps){
    if (this.props.inCart && !prevProps.inCart) {
      this.setState({ loading: false });
    }
  }

  handleBtn = () => {
    const { product, handleCart } = this.props;
    this.setState({ loading: true });
    handleCart(product.id)();
  }

  render() {
    const { loading } = this.state;
    const { inCart, product, style, intl } = this.props;

    return (
      inCart
        ? <Link className={classNames(style.cartBtn, style.cartBtnChecked)} to="/cart" title={intl.formatMessage({id: 'Product.GO_IN_CART'})}>
            {loading
              ? <img alt='' className={style.loading} src={loader} /> 
              : <>
                  <FontAwesomeIcon icon="check" />
                  <img alt='' src={lorry} />
                </>
            }
          </Link>
        : product.ends === 1 && product.instock === 0 
          ? <button className={style.cartBtn} type="button" disabled="disabled" title={intl.formatMessage({id: 'Good.NOT_AVAILABLE'})}>
              <img alt='' src={van} />
              <FormattedMessage id="Product.ADD_IN_CART" />
            </button>
          : <button className={style.cartBtn} type="button" onClick={this.handleBtn}>
              {loading 
                ? <img alt='' className={style.loading} src={loader} /> 
                : <>
                    <img alt='' src={van} />
                    <FormattedMessage id="Product.ADD_IN_CART" />
                  </>
              }
            </button>
    )
  }
}

BtnCart.defaultProps = {
  inCart: false
};

BtnCart.propTypes = {
  inCart: PropTypes.bool,
  product: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
  handleCart: PropTypes.func.isRequired,
  addedToCart: PropTypes.object,
};

export default BtnCart;